module.exports = __webpack_public_path__ + "img/3.eb6f3ca0.jpg";